<template>
  <div class="page-AddSchool">
    <div class="top-line">
      <div class="small-button" @click="toBack()">返回</div>
      <span class="title"> 添加幼儿园帐号 </span>
    </div>
    <div class="content">
      <div class="add-line">
        <div class="add-line-title">注册手机号：</div>
        <div class="add-line-content">
          <el-input
            v-model="schoolPhone"
            placeholder="请输入手机号"
            style="width: 266px"
            @blur="phoneBlur"
          ></el-input>
        </div>
      </div>
      <div class="add-line">
        <div class="add-line-title">联系人姓名：</div>
        <div class="add-line-content">
          <el-input
            v-model="schoolUser"
            placeholder="请输入姓名"
            style="width: 266px"
          ></el-input>
        </div>
      </div>
      <div class="add-line">
        <div class="add-line-title">幼儿园所在地区：</div>
        <div class="add-line-content">
          <el-select
            v-model="provinceValue"
            clearable
            placeholder="省"
            style="width: 170px; margin-right: 10px"
            @change="selectProvince()"
          >
            <el-option
              v-for="(item, index) in provinceList"
              :key="index"
              :label="item.name"
              :value="item.province_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="cityValue"
            clearable
            placeholder="市"
            style="width: 170px; margin-right: 10px"
            @change="selectCity()"
          >
            <el-option
              v-for="(item, index) in cityList"
              :key="index"
              :label="item.name"
              :value="item.city_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="areaValue"
            clearable
            placeholder="区/县"
            style="width: 170px; margin-right: 10px"
            @change="selectArea()"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.name"
              :value="item.area_id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="add-line">
        <div class="add-line-title">注册幼儿园名称：</div>
        <div class="add-line-content">
          <el-input
            v-model="schoolName"
            placeholder="请填写幼儿园名称"
            style="width: 366px"
          ></el-input>
        </div>
      </div>
      <div class="submit-box">
        <div class="submit-btn" @click="submit">提交</div>
        <div class="submit-des">
          * 点击提交将自动给注册手机号发送注册成功短信
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { province, city, area, add_school_account } from '@/api/api.js'
export default {
  name: 'Search',
  data: () => ({
    provinceList: [], // 省
    provinceValue: '',
    cityList: [], // 市
    cityValue: '',
    areaList: [], // 区
    areaValue: '',
    schoolList: [], // 学校
    schoolValue: '',
    schoolPhone: '',
    schoolUser: '',
    schoolName: '',
  }),
  mounted() {
    this.getProvince()
  },
  methods: {
    toBack() {
      this.$router.back()
    },
    getProvince() {
      if (this.provinceList.length == 0) {
        province().then((res) => {
          // console.log('province', res)
          this.provinceList = res.data.data
        })
      }
    },
    selectProvince() {
      // console.log('provinceValue', this.provinceValue)
      city({ province_id: this.provinceValue }).then((res) => {
        // console.log('city', res)
        this.cityList = res.data.data
        this.cityValue = ''
        this.areaList = []
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      })
    },
    selectCity() {
      // console.log('cityValue', this.cityValue)
      area({ city_id: this.cityValue }).then((res) => {
        // console.log('area', res)
        this.areaList = res.data.data
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      })
    },
    selectArea() {},

    phoneBlur() {
      if (!this.schoolPhone) {
        this.$message.error('请填写完整手机号!')
        return
      }
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.schoolPhone)) {
        this.$message.error('请填写正确手机号!')
        return
      }
    },

    submit() {
      if (!this.schoolPhone) {
        this.$message.error('请填写完整手机号!')
        return
      }
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(this.schoolPhone)) {
        this.$message.error('请填写正确手机号!')
        return
      }
      if (!this.schoolUser) {
        this.$message.error('请填写联系人姓名!')
        return
      }
      if (!this.provinceValue || !this.cityValue || !this.areaValue) {
        this.$message.error('请选择所在地区!')
        return
      }
      if (!this.schoolName) {
        this.$message.error('请填写幼儿园名称!')
        return
      }
      let data = {
        phone: this.schoolPhone,
        real_name: this.schoolUser,
        nick_name: this.schoolName,
        province_id: this.provinceValue,
        city_id: this.cityValue,
        area_id: this.areaValue,
      }
      add_school_account(data).then((res) => {
        if (res.data.msg == '短信发送失败') {
          this.$message.error('短信发送失败!')
          return
        }
        if (res.data.msg == '账号已存在') {
          this.$message.error('该手机号已被注册！')
          return
        }
        this.$message({
          message: '创建成功！',
          type: 'success',
        })
        setTimeout(() => {
          this.toBack()
        }, 500)
      })
    },
  },
}
</script>

<style lang="less" scoped>
.page-AddSchool {
  .top-line {
    display: flex;
    height: 84px;
    width: calc(100vw - 320px);
    max-width: 1600px;
    // min-width: 1561px;
    margin: 0 auto;
    padding-left: 40px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }

  .content {
    position: relative;
    width: calc(100vw - 320px);
    max-width: 1600px;
    min-height: calc(100vh - 220px);
    // min-width: 1561px;
    margin: 0 auto;
    padding-top: 25px;
    padding-bottom: 10px;
    background-color: #fff;
    box-sizing: border-box;
    .add-line {
      display: flex;
      align-items: center;
      height: 70px;
      .add-line-title {
        width: 210px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
        line-height: 16px;
        text-align: right;
      }
      .add-line-content {
        margin-left: 7px;
      }
    }
    .submit-box {
      margin: 45px 0 0 217px;
      .submit-btn {
        width: 121px;
        height: 40px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        background: #27b2fe;
        border-radius: 4px;
        cursor: pointer;
      }
      .submit-des {
        margin-top: 9px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
      }
    }
  }
}
</style>
